import React from 'react';
import { Link } from 'react-router-dom';
import { FaTrophy, FaFacebook, FaTwitter, FaInstagram, FaEnvelope } from 'react-icons/fa';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative mt-24 border-t border-white/10 bg-gradient-to-t from-black/50 to-transparent">
      <div className="absolute inset-0 bg-gradient-to-t from-cyan-500/5 via-purple-500/5 to-transparent"></div>
      <div className="relative container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand Section */}
          <div className="space-y-5">
            <Link to="/" className="flex items-center space-x-3 group">
              <div className="relative">
                <div className="w-12 h-12 bg-gradient-to-br from-cyan-500 via-purple-500 to-pink-500 rounded-2xl flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform">
                  <img 
                    src="/images/logo.webp" 
                    alt="logo" 
                    className="w-12 h-12 object-contain"
                    width="48"
                    height="48"
                    loading="lazy"
                    decoding="async"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-br from-cyan-500 via-purple-500 to-pink-500 rounded-2xl blur-lg opacity-50 -z-10"></div>
              </div>
              <span className="text-2xl font-black heading-font text-gradient">Parismin</span>
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed">
              Votre guide expert pour les meilleures offres de paris sportifs en France. 
              Comparaisons détaillées, avis authentiques et bonus exclusifs.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-bold text-lg mb-6 text-gradient heading-font">Navigation</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-white transition-colors">
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/reviews" className="text-gray-400 hover:text-white transition-colors">
                  Avis des Bookmakers
                </Link>
              </li>
              <li>
                <Link to="/comparisons" className="text-gray-400 hover:text-white transition-colors">
                  Comparaisons
                </Link>
              </li>
              <li>
                <Link to="/bonuses" className="text-gray-400 hover:text-white transition-colors">
                  Bonus & Promotions
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="font-bold text-lg mb-6 text-gradient heading-font">Informations</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-gray-400 hover:text-white transition-colors">
                  À propos
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-white transition-colors">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-gray-400 hover:text-white transition-colors">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-gray-400 hover:text-white transition-colors">
                  Conditions d'utilisation
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-gray-400 hover:text-white transition-colors">
                  Politique de confidentialité
                </Link>
              </li>
              <li>
                <Link to="/cookies" className="text-gray-400 hover:text-white transition-colors">
                  Politique des cookies
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Regulatory Organizations */}
        <div className="mt-12 pt-8 border-t border-white/10">
          <div className="flex flex-wrap items-center justify-center gap-6 md:gap-8 mb-8">
            <a
              href="https://anj.fr/"
              target="_blank"
              rel="noopener noreferrer"
              className="opacity-70 hover:opacity-100 transition-opacity"
              title="Autorité Nationale des Jeux"
            >
              <img
                src="/images/footer/anj.webp"
                alt="ANJ - Autorité Nationale des Jeux"
                className="h-12 w-auto object-contain"
                width="48"
                height="48"
                loading="lazy"
                decoding="async"
              />
            </a>
            <a
              href="https://www.hippodromesenfete.fr/jouons-responsable/"
              target="_blank"
              rel="noopener noreferrer"
              className="opacity-70 hover:opacity-100 transition-opacity"
              title="Jouons Responsable"
            >
              <img
                src="/images/footer/jouns.webp"
                alt="Jouons Responsable"
                className="h-12 w-auto object-contain"
                width="48"
                height="48"
                loading="lazy"
                decoding="async"
              />
            </a>
            <a
              href="https://www.data.gouv.fr/en/organizations/autorite-de-regulation-des-jeux-en-ligne-arjel/"
              target="_blank"
              rel="noopener noreferrer"
              className="opacity-70 hover:opacity-100 transition-opacity"
              title="ARJEL"
            >
              <img
                src="/images/footer/arjel.webp"
                alt="ARJEL - Autorité de Régulation des Jeux en Ligne"
                className="h-12 w-auto object-contain"
                width="48"
                height="48"
                loading="lazy"
                decoding="async"
              />
            </a>
            <a
              href="https://mediateurdesjeuxenligne.fr/"
              target="_blank"
              rel="noopener noreferrer"
              className="opacity-70 hover:opacity-100 transition-opacity"
              title="Médiateur des Jeux en Ligne"
            >
              <img
                src="/images/footer/mediater.webp"
                alt="Médiateur des Jeux en Ligne"
                className="h-12 w-auto object-contain"
                width="48"
                height="48"
                loading="lazy"
                decoding="async"
              />
            </a>
            <a
              href="https://www.gambleaware.org/"
              target="_blank"
              rel="noopener noreferrer"
              className="opacity-70 hover:opacity-100 transition-opacity"
              title="BeGambleAware"
            >
              <img
                src="/images/footer/begamble.webp"
                alt="BeGambleAware"
                className="h-12 w-auto object-contain"
                width="48"
                height="48"
                loading="lazy"
                decoding="async"
              />
            </a>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-white/10 text-center">
          <p className="text-gray-400 text-sm">
            &copy; {currentYear} <span className="text-gradient font-bold">Parismin.com</span> - Tous droits réservés
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

